import { Component } from '@angular/core';

@Component({
    selector: 'wre-access-tab',
    templateUrl: './access-tab.component.html',
    styleUrls: ['./access-tab.component.sass'],
    standalone: false
})
export class AccessTabComponent { }
